import { render } from "./ControlsGuide.vue?vue&type=template&id=da62bb4a&scoped=true"
import script from "./ControlsGuide.vue?vue&type=script&lang=js"
export * from "./ControlsGuide.vue?vue&type=script&lang=js"

import "./ControlsGuide.vue?vue&type=style&index=0&id=da62bb4a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-da62bb4a"

export default script